// Mirrors the backend's utils/rich_text.py conventions (one <p> per line) for callers holding a
// section's text as a plain string rather than a live TipTap editor.

export function htmlToPlainText(html: string): string {
  if (!html) return '';
  const container = document.createElement('div');
  container.innerHTML = html;
  container.querySelectorAll('br').forEach((br) => br.replaceWith('\n'));
  const lines: string[] = [];
  let current = '';
  let seenParagraph = false;
  container.childNodes.forEach((node) => {
    if (node.nodeType === Node.ELEMENT_NODE && (node as Element).tagName === 'P') {
      if (seenParagraph) {
        lines.push(current);
        current = '';
      }
      seenParagraph = true;
    }
    current += node.textContent ?? '';
  });
  lines.push(current);
  return lines.join('\n');
}

// TipTap's canonical empty doc serializes to "<p></p>", not "" — normalize so callers can treat
// "" as empty.
export function normalizeEmptyHtml(html: string): string {
  return html === '<p></p>' ? '' : html;
}
